import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { VStack } from '@ayble-health/dashboard-components';
import type { ProviderTask } from '../../models/providerHome';
import { TaskCard } from './TaskCard';
import { EmptyColumnState } from './EmptyColumnState';

type Props = { tasks: ProviderTask[] };

export const TasksColumn = ({ tasks }: Props) => {
  if (tasks.length === 0) {
    return (
      <EmptyColumnState
        heading="Nice job — you have no more tasks today"
        subhead="Go enjoy your day, and thanks for the hard work!"
      />
    );
  }
  return (
    <VStack gap={2} align="stretch">
      <AnimatePresence mode="popLayout">
        {tasks.map((task) => (
          <motion.div
            key={task.id}
            layout
            exit={{ opacity: 0, x: 16, transition: { duration: 0.15, ease: 'easeIn' } }}
          >
            <TaskCard task={task} />
          </motion.div>
        ))}
      </AnimatePresence>
    </VStack>
  );
};
